import Vue from 'vue';

Vue.directive('drag-resize', {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dragDom.style.overflow = 'auto';
    dialogHeaderEl.style.cursor = 'move';


    let isResizing = false;
    let startX, startY, startWidth, startHeight;

    dialogHeaderEl.onmousedown = (e) => {
      // 拖拽移动逻辑
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      document.onmousemove = (e) => {
        const l = e.clientX - disX;
        const t = e.clientY - disY;
        dragDom.style.left = `${l}px`;
        dragDom.style.top = `${t}px`;
      };

      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };

    const resizeHandle = document.createElement('div');
    resizeHandle.style.position = 'absolute';
    resizeHandle.style.width = '10px';
    resizeHandle.style.height = '10px';
    resizeHandle.style.right = '0';
    resizeHandle.style.bottom = '0';
    resizeHandle.style.cursor = 'se-resize';
    resizeHandle.style.backgroundColor = '#ccc';
    dragDom.appendChild(resizeHandle);

    resizeHandle.onmousedown = (e) => {
      isResizing = true;
      startX = e.clientX;
      startY = e.clientY;
      startWidth = dragDom.offsetWidth;
      startHeight = dragDom.offsetHeight;

      document.onmousemove = (e) => {
        if (isResizing) {
          const newWidth = startWidth + (e.clientX - startX);
          const newHeight = startHeight + (e.clientY - startY);
          dragDom.style.width = `${newWidth > 100 ? newWidth : 100}px`; // 设置最小宽度
          dragDom.style.height = `${newHeight > 100 ? newHeight : 100}px`; // 设置最小高度

          const dragDomBody = el.querySelector('.el-dialog__body')
          console.log(dragDomBody.style)
          dragDomBody.style.height = `${newHeight - (el.querySelector('.el-dialog__header')?.offsetHeight || 0) - 40 }px`;
          dragDomBody.style.maxHeight = 'none';
          const iframe = el.querySelector('iframe');
            if (iframe) {
              iframe.style.width = `100%`;
              iframe.style.height = `${newHeight - (el.querySelector('.el-dialog__header')?.offsetHeight || 0) - 50 }px`; // 减去头部高度
            }
        }
      };

      document.onmouseup = () => {
        isResizing = false;
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  },
});



// WEBPACK FOOTER //
// ./src/utils/drag-resize.js